import { createContext, useContext, useEffect, useReducer } from "react";

const AuthContext = createContext();

const actionReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    case "LOGOUT":
      return {
        ...state,
        user: {
          userEmail: "",
          userToken: "",
          userName: "",
          userId: "",
        },
        isAuthenticated: false,
        isLoginPopUp: false,
        isLoggedInByPricing: false,
        setOpen: false,
      };
    case "LOGINPOPUP":
      return {
        ...state,
        isLoginPopUp: action.payload.isLoginPopUp,
        isLoggedInByPricing: action.payload.isLoggedInByPricing,
      };
    default:
      return state;
  }
};

const AuthContextProvider = ({ children }) => {
  const [userState, dispatcher] = useReducer(actionReducer, {
    user: {
      userEmail: "",
      userToken: "",
      userName: "",
      userId: "",
    },
    isAuthenticated: false,
    setOpen: false,
    isLoginPopUp: false,
    isLoggedInByPricing: false,
  });

  useEffect(() => {
    const user = localStorage.getItem("flowedit:user");
    if (user) {
      try {
        const parsedUser = JSON.parse(user);
        if (parsedUser) {
          dispatcher({
            type: "LOGIN",
            payload: parsedUser,
          });
        }
      } catch (error) {
        console.error("Failed to parse user data from localStorage:", error);
      }
    }
  }, []);

  return (
    <AuthContext.Provider value={{ ...userState, dispatcher }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthContextProvider };
